import React from 'react'

const DocCustomUrl =(props)=>{
    const {formObject, viewData} = props;

    const valCssClass = formObject.getValueFromKey(viewData, "dataList.valCssClass", "");

    return (
        <div className="saras-cell">
            <a target='_blank' rel="noopener noreferrer"
            className={`uiLink ${valCssClass}`} href={viewData.val}>{viewData.valF || viewData.val}</a>
        </div>
    )
}

export default DocCustomUrl